import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import asyncService from "../../services/common/asyncService";
import pocs from "../../services/pocs";
import sessionStore from "../../store/sessionStore";
import authService from "../../services/common/authService";
import { isNotEmpty } from "../../util/util";
import rootScope from "../../store/rootScopeStore";
const Menu = observer(() => {
    const dispatch = useDispatch();

    const [announceData, setAnnounceData] = useState([]);

    useEffect(() => {
        if (!!authService.getUser()) {
            getAnnouncement();
        }
    }, []);

    useEffect(() => {
        if (!sessionStore.getSuggestItems('shin') && authService.getUser() && authService.getUser().tksakicd) {
            dispatch(asyncService.async(pocs.getShin(authService.getUser().tksakicd), (response) => {
                const data = response.data;
                if (data.length > 0) {
                    sessionStore.setSuggestItems('shin', data);
                }
            
            }));
        }
        
    });

    // アナウンス情報を取得
    const getAnnouncement = () => {
        dispatch(asyncService.async(pocs.getAnnouncement(), (response) => {
            if (response.data && response.data.length > 0 && !!authService.getUser()) {
                setAnnounceData(response.data);
            }
        }));
    }

    return (
        <>
            <div>
                <div style={{ marginLeft: '40%', marginTop: '50px', display: rootScope.hiddenFlg ? 'none' : '' }} >
                    <Link to="/Jyuf104/1">
                        <button className="btn ng-binding">注文入力</button>
                    </Link>
                </div>
                <div style={{ marginLeft: '40%', marginTop: '20px', display: rootScope.hiddenFlg ? 'none' : '' }} >
                    <Link to="/Jyuf105">
                        <button className="btn ng-binding">注文一覧</button>
                    </Link>
                </div>
                {
                    authService.getUser() && rootScope.kbn["SIKYUHKOKBN"] && authService.getUser().sikyuhkokbn == rootScope.kbn["SIKYUHKOKBN"].ARN.code ?
                        <div style={{ marginLeft: '40%', marginTop: '20px', display: rootScope.hiddenFlg ? 'none' : '' }} >
                            <Link to="/Skyf101">
                                <button className="btn ng-binding">請求書一覧</button>
                            </Link>
                        </div> : ''
                }
            </div>
            <div className="mt40"></div>
            {
                authService.getUser() && announceData?.length > 0 ?
                announceData.map((data, index) => 
                    <div className="mt15 announce-text" style={{ display: rootScope.hiddenFlg ? 'none' : '' }} >
                        <div className="title">{data.titleName}</div>
                        <div className="contents">{data.content}</div>
                    </div>
                )
                : ''
            }
            
        </>
    )
})
export default Menu;